// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanarySummaryAmountsTsx from "./CanarySummaryAmounts.tsx";

let make = CanarySummaryAmountsTsx.SummaryAmountsLine;

let Line = {
  make: make
};

let make$1 = CanarySummaryAmountsTsx.SummaryAmountsGap;

let Gap = {
  make: make$1
};

let make$2 = CanarySummaryAmountsTsx.SummaryAmountsCaption;

let Caption = {
  make: make$2
};

let make$3 = CanarySummaryAmountsTsx.SummaryAmounts;

export {
  Line,
  Gap,
  Caption,
  make$3 as make,
}
/* make Not a pure module */
